import { render, staticRenderFns } from "./ContentBody.vue?vue&type=template&id=47df4a4a&"
import script from "./ContentBody.vue?vue&type=script&lang=js&"
export * from "./ContentBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47df4a4a')) {
      api.createRecord('47df4a4a', component.options)
    } else {
      api.reload('47df4a4a', component.options)
    }
    module.hot.accept("./ContentBody.vue?vue&type=template&id=47df4a4a&", function () {
      api.rerender('47df4a4a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/ContentBody.vue"
export default component.exports